export default __webpack_public_path__ + "static/media/front.305456b1.png";